
const options = (messageBody) => ({
  withCredentials: true,
  data: messageBody
});

const post = async (path, client, messageBody) => {
  return client.post(path, options(messageBody));
};
export default post;